import { createModelSchemaWrapper, rawCopy } from 'framework/serializr-integration';
import { makeAutoObservable } from 'mobx';
import { ThemedColor } from 'framework/colors/types';

export type ColorPickerProps = {
	value?: string;
	onChange?: (hex: string) => void;
	disableAlpha?: boolean;
	className?: string;
};

export type ColorPalette = {
	id: string;
	name: string;
	colors: ThemedColor[];
};

export class PaletteSettings {
	palettes: ColorPalette[];

	constructor() {
		makeAutoObservable(this);
	}
}

createModelSchemaWrapper(PaletteSettings, {
	palettes: rawCopy(),
});
